module.exports = __webpack_public_path__ + "assets/img/1587368007079.b14ff471.jpg";